export const columns = function () {
  return [
    {
      prop: "insBillId",
      label: "流水号",
      minWidth: 100,
    },
    {
      prop: "orgName",
      label: "机构名称",
      minWidth: 100,
    },
    {
      prop: "realname",
      label: "业务员",
      minWidth: 100,
    },
    {
      prop: "carNo",
      label: "车牌号",
      sortable: true,
      minWidth: 100,
    },
    {
      prop: "gh_amount",
      label: "公户金额(元)",
      sortable: true,
      minWidth: 100,
    },
    {
      prop: "gh_qrcode_amount",
      label: "公户收款码收入(元)",
      sortable: true,
      minWidth: 200,
    },
    {
      prop: "wx_qrcode_amount",
      label: "微信收款码收入(元)",
      minWidth: 200,
    },
	{
	  prop: "other_amount",
	  label: "其他金额(元)",
	  minWidth: 100,
	},
    {
      prop: "confirmPayNo",
      label: "操作工号",
      minWidth: 100,
    },
    {
      prop: "type",
      label: "是否财务补录",
      minWidth: 100,
      slotName: "type",
    },
  ];
};

export default {};
